import React, { useState } from "react";
import { PlusCircle, Edit, Trash2 } from "react-feather";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import DataTable from "../../../components/common/DataTable";
import { confirmDelete } from "../../../components/common/ConfirmDialog";
import {
  useGetDesignationsQuery,
  useDeleteDesignationMutation,
} from "../designationsApi";
import DesignationCreateModal from "../components/DesignationCreateModal";
import DesignationEditModal from "../components/DesignationEditModal";

const DesignationsList = () => {
  const { data: designations = [], isLoading } = useGetDesignationsQuery();
  const [deleteDesignation] = useDeleteDesignationMutation();
  const [showCreate, setShowCreate] = useState(false);
  const [editingDesignationId, setEditingDesignationId] = useState(null);

  const handleDelete = async (designation) => {
    const confirmed = await confirmDelete({
      title: `Delete ${designation.designationName}?`,
    });
    if (!confirmed) return;
    try {
      await deleteDesignation(designation.designationId).unwrap();
      toast.success("Designation deleted");
    } catch (error) {
      toast.error(error?.message || "Could not delete designation");
    }
  };

  const columns = [
    { title: "Code", dataIndex: "designationCode" },
    { title: "Name", dataIndex: "designationName" },
    {
      title: "Created",
      dataIndex: "createdDate",
      render: (value) => (value ? dayjs(value).format("DD MMM YYYY") : "-"),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, designation) => (
        <div className="edit-delete-action">
          <button
            type="button"
            className="btn btn-link me-2 p-2"
            onClick={() => setEditingDesignationId(designation.designationId)}
          >
            <Edit size={16} />
          </button>
          <button
            type="button"
            className="btn btn-link p-2 text-danger"
            onClick={() => handleDelete(designation)}
          >
            <Trash2 size={16} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Designations</h4>
              <h6>Job-title default permissions</h6>
            </div>
          </div>
          <div className="page-btn">
            <button
              type="button"
              className="btn btn-added"
              onClick={() => setShowCreate(true)}
            >
              <PlusCircle className="me-2" size={16} />
              Add New Designation
            </button>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <DataTable
                columns={columns}
                dataSource={designations}
                rowKey="designationId"
                loading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>

      <DesignationCreateModal
        show={showCreate}
        onClose={() => setShowCreate(false)}
      />
      <DesignationEditModal
        designationId={editingDesignationId}
        onClose={() => setEditingDesignationId(null)}
      />
    </div>
  );
};

export default DesignationsList;
